export const environment = {
  environment: 'production-global',
  mapboxToken: 'pk.eyJ1IjoiYmVleGFjdCIsImEiOiJjbHZkdzZkczYwMnpiMmpudnBkYWQ1MGdvIn0.rNIM2c2FAiDtJO9oJcVq9w',
  msal: {
    clientId: '40624b13-b1e0-4592-a6f5-4607115b793b',
    tenantId: 'https://login.microsoftonline.com/39f5a7e8-c624-4a45-8214-a315c7749e03',
    redirectUri: `https://scanxact.beexact.com/redirect`,
  },
  api: 'https://api.scanxact.beexact.com',
};
